import { createSelector } from 'reselect'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'
import { selectLoggedIn } from 'selectors/accountSelectors'

/**
 * Whether a logged-in customer can be offered to join Société: they have no account, and it isn't
 * loading or failed to load. A closed account fails to load, so it's never offered to join. Neither
 * is an account that failed for another reason, since enrolment refuses any account in error.
 */
const getCanJoinLoyalty = createSelector(
  (state: App.State) => getIsLoyaltyEnabled(state),
  (state: App.State) => selectLoggedIn(state),
  (state: App.State) => state.loyalty.account,
  (loyaltyEnabled, isLoggedIn, loyaltyAccount): boolean => {
    if (!loyaltyEnabled || !isLoggedIn) return false
    if (loyaltyAccount.fetching || loyaltyAccount.error) return false
    return !loyaltyAccount.data
  },
)

export default getCanJoinLoyalty
